import type { PlaycastGamepadId, PlaycastGamepadState, PlaycastGamepadXInput } from '@playcastdotio/CoreTypes';
import type {
  PlaycastMessage,
  PlaycastMessageGamepadInitialize,
  PlaycastMessageGamepadGetSessionState,
  PlaycastMessageGamepadRemove,
  PlaycastMessageGamepadSetState,
  PlaycastMessageGamepadSetXInput,
  PlaycastMessageHostGamepadGetStatus,
  PlaycastMessageSource,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'gamepad';

/**
 * @experimental This is an experimental feature and may be changed in the future.
 */
export const experimentalInitialize = (
  gamepadId: PlaycastGamepadId,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageGamepadInitialize> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageGamepadInitialize = {
    target,
    action: 'initialize',
    isReply: false,
    message: {
      gamepadId,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageGamepadInitialize>;
};

/**
 * @experimental This is an experimental feature and may be changed in the future.
 */
export const experimentalRemove = (gamepadId: PlaycastGamepadId, userAuth?: string): PlaycastMessage<PlaycastMessageGamepadRemove> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageGamepadRemove = {
    target,
    action: 'remove',
    isReply: false,
    message: {
      gamepadId,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageGamepadRemove>;
};

export const setState = (
  hostId: string,
  state: PlaycastGamepadState,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageGamepadSetState> => {
  const messageSource: PlaycastMessageSource = 'player';
  const message: PlaycastMessageGamepadSetState = {
    target,
    action: 'setState',
    isReply: false,
    message: state,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageGamepadSetState>;
};

export const initialize = (
  hostId: string,
  gamepadId: PlaycastGamepadId,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageGamepadInitialize> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageGamepadInitialize = {
    target,
    action: 'initialize',
    isReply: false,
    message: {
      gamepadId,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageGamepadInitialize>;
};

export const remove = (hostId: string, gamepadId: PlaycastGamepadId, userAuth?: string): PlaycastMessage<PlaycastMessageGamepadRemove> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageGamepadRemove = {
    target,
    action: 'remove',
    isReply: false,
    message: {
      gamepadId,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageGamepadRemove>;
};

export const setXInput = (
  hostId: string,
  xInput: PlaycastGamepadXInput,
  userAuth?: string,
  messageSource?: PlaycastMessageSource,
): PlaycastMessage<PlaycastMessageGamepadSetXInput> => {
  if (!messageSource) messageSource = 'host';
  const message: PlaycastMessageGamepadSetXInput = {
    target,
    action: 'setXInput',
    isReply: false,
    message: xInput,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageGamepadSetXInput>;
};

export const getStatus = (userAuth?: string): PlaycastMessage<PlaycastMessageHostGamepadGetStatus> => {
  const hostId = 'experimental';
  const messageSource = 'host';
  const message: PlaycastMessageHostGamepadGetStatus = {
    target,
    action: 'getStatus',
    isReply: false,
    message: {},
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageHostGamepadGetStatus>;
};

export const getSessionState = (
  hostId: string,
  targetSessionId: string,
  gamepadId: PlaycastGamepadId,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageGamepadGetSessionState> => {
  const message: PlaycastMessageGamepadGetSessionState = {
    target,
    action: 'getSessionState',
    isReply: false,
    message: {
      targetSessionId,
      gamepadId,
    },
  };
  return formatMessage(hostId, 'host', message, userAuth) as PlaycastMessage<PlaycastMessageGamepadGetSessionState>;
};
